const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getReportProfiles(orgId, filters = {}) {
  const params = new URLSearchParams();
  if (filters.programId) params.append('programId', filters.programId);
  if (filters.status) params.append('status', filters.status);
  if (filters.reportTypeId) params.append('reportTypeId', filters.reportTypeId);
  
  const queryString = params.toString();
  const url = `${API_BASE}/orgs/${orgId}/report-profiles${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch report profiles');
  }
  
  const data = await response.json();
  return data.profiles;
}

export async function getReportProfile(orgId, profileId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/report-profiles/${profileId}`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Report profile not found');
    }
    throw new Error('Failed to fetch report profile');
  }
  
  const data = await response.json();
  return data.profile;
}

export async function getReportProfileVersions(orgId, profileId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/report-profiles/${profileId}/versions`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch profile versions');
  }
  
  const data = await response.json();
  return data.versions;
}

export async function createReportProfile(orgId, data) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/report-profiles`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(data)
  });
  
  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('You do not have permission to create report profiles');
    }
    throw new Error('Failed to create report profile');
  }
  
  const result = await response.json();
  return result.profile;
}

export async function updateReportProfile(orgId, profileId, updates) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/report-profiles/${profileId}`, {
    method: 'PATCH',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(updates)
  });
  
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    if (response.status === 400 && data.error) {
      throw new Error(data.error);
    }
    throw new Error('Failed to update report profile');
  }
  
  const result = await response.json();
  return result.profile;
}

export async function publishReportProfile(orgId, profileId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/report-profiles/${profileId}/publish`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify({})
  });
  
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    if (response.status === 400 && data.error) {
      throw new Error(data.error);
    }
    throw new Error('Failed to publish report profile');
  }
  
  return response.json();
}

export async function createDraftFromProfile(orgId, profileId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/report-profiles/${profileId}/create-draft`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify({})
  });
  
  if (!response.ok) {
    throw new Error('Failed to create draft from profile');
  }
  
  const result = await response.json();
  return result.profile;
}
